<template>
  <div class="topTitleBox">
      <div class="dateTimeBox">
        <div class="dateTimeBox-after"></div>
          <div class="count-time">
          <span class="count-time-tip">统计时间:</span>
          <el-radio-group v-model="countState" size="small" @input="changeCountState">
            <el-radio-button label="今天"></el-radio-button>
            <el-radio-button label="昨天"></el-radio-button>
            <el-radio-button label="最近7天"></el-radio-button>
            <el-radio-button label="最近30天"></el-radio-button>
            <el-radio-button label="自定义"></el-radio-button>
          </el-radio-group>
          <el-date-picker
          popper-class="count-time-date"
          v-show="countState=='自定义'"
          v-model="monthValue"
          size="small"
          @change="changeMouth"
          style="margin-left: 10px;"
          type="monthrange"
          value-format="YYYY-MM-dd"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份">
        </el-date-picker>
        </div>
      </div>
      <dv-decoration-10 style="width: 33.33%; height: 10px; margin-top: 20px" />
      <div class="leftDecorate">
        <!-- <p v-for="(item,index) in navList" :key="index" @click="jumpRouter(item.path)"><dv-decoration-7   class="menu" style="height: 30px"
              ><span >{{ item.title }}</span></dv-decoration-7></p> -->
        <span class="dateText">
          <dv-decoration-7 style="height: 30px"
            >{{ dateYear }} {{ dateWeek }} {{ dateDay }}</dv-decoration-7
          >
          <el-button v-if="isShowWanWei" size="small" type="primary" @click="expotExcel">试点单位数据下载</el-button>
        </span>
      </div>
      <dv-decoration-8
        :color="['#568aea', '#000000']"
        style="width: 10%; height: 50px; margin-top: 25px"
      />
      <div class="title">
        <dv-decoration-5
          :dur="2"
          :color="['#568aea', '#568aea']"
          style="width: 100%; height: 30px"
        /><span>文档工具数据可视化平台</span>
        <dv-decoration-6
          class="title-bototm"
          :reverse="true"
          :color="['#50e3c2', '#67a1e5']"
          style="width: 250px; height: 10px"
        />
      </div>
      <dv-decoration-8
        :reverse="true"
        :color="['#568aea', '#000000']"
        style="width: 10%; height: 50px; margin-top: 20px"
      />
      <dv-decoration-10
        style="width: 33.33%;height: 10px;margin-top: 15px; transform: rotateY(180deg);" />
    </div>
</template>
<script>
import { msgAPI } from 'liankong-ui-api'
export default {
  name: "Home",
  components: {},
  data() {
    return {
      isShowWanWei:false,
      timer:null,
      dateDay: null, //时间
      dateYear: null,
      dateWeek: null,
      monthValue:'',
      countState:'今天',
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      navList:[{title:'首页',path:'/managerLange'},{title:'统计',path:'/managerStatistics'},{title:'告警',path:'/earlyWarning'}]
    };
  },
  created() {},
  mounted() {
    this.timeFn();
    msgAPI.getWanWeiConfigKey().then(res=>{
        if(res.code==0){
            this.isShowWanWei = res.data == 'true'
        }
    })
  },
  methods: {
    expotExcel(){
      window.open(`/api/v1/tool/wanwei/export`)
    },
    changeCountState(){
      this.monthValue = ''
      this.$emit('changeCountState', this.countState);
    },
    changeMouth(){
        this.$emit('changeMouth',this.monthValue)
    },
    jumpRouter(path){
      this.$router.push(path)
    },
    timeFn() {
      //获取时间
     this.timer = null
     this.timer =  setInterval(() => {
        this.dateDay = this.formatTimes(new Date(), "HH: mm: ss");
        this.dateYear = this.formatTimes(new Date(), "yyyy-MM-dd");
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000);
    },
    formatTimes(time, fmt) {
      if (!time) return "";
      else {
        const date = new Date(time);
        const o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "H+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          S: date.getMilliseconds(),
        };
        if (/(y+)/.test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        for (const k in o) {
          if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length === 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
          }
        }
        return fmt;
      }
    },
  },
  destroyed(){
    clearInterval(this.timer)
  }
};
</script>
<style lang="less" scoped>

.topTitleBox {
    width: 100%;
    height: 80px;
    display: flex;
    position: relative;
    .leftDecorate {
      position: absolute;
      // left: 7%;
      top: 32px;
      width: 29%;
      padding-right: 50px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      background-color: rgb(15, 19, 37);
      color: #fff;
      .dateText {
        width: 100%;
        display: flex;
      }
      p {
        margin: 0;
        padding: 0;
        .menu {
          cursor: pointer;
          span {
            padding: 0 5px;
            color: #06f1ef;
            background-color: #0f1325;
          }
        }
      }
    }
    .dateTimeBox {
      position: absolute;
      right: 0.5%;
      top: 27px;
      color: #06f1ef;
      font-size: 20px;
      // background-color: rgb(15, 19, 37);
      width: 28.5%;
      height: 50px;
      text-align: center;
      cursor: pointer;
      .count-time {
        position: relative;
        // background: #fff;
        .count-time-tip {
          margin-left: 20px;
          font-size: 16px;
          color: #fff;
          font-weight: bold;
          margin-right: 10px;
        }
        .el-radio-group {
          /deep/ .el-radio-button{
            .el-radio-button__inner {
              background: #1f252f !important;
              color:#fff !important;
            }
            .el-radio-button__orig-radio:checked+.el-radio-button__inner {
              background: #fff !important;
              color: #606266 !important;
              border-color:#fff;
            }
          }
        }
        .el-date-editor {
          position: absolute;
          top: 33px;
          right: 0;
         /deep/ .el-range-separator{
            padding: 0px;
          }
        }
        .count-time-date {

        }
      }
    }
    .title {
      width: 500px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      font-size: 25px;
      color: white;
    }
  }
</style>
